import React from 'react';

interface PatientNameTemplateProps {
  firstName?: string | null;
  lastName?: string | null;
}

/**
 * Displays patient full name (first + last).
 */
export const PatientNameTemplate: React.FC<PatientNameTemplateProps> = ({ firstName, lastName }) => {
  const fullName = `${firstName || ''} ${lastName || ''}`.trim();
  return <span>{fullName || '-'}</span>;
};

/** Syncfusion grid template wrapper */
export const patientTemplate = (props: any) => (
  <PatientNameTemplate 
    firstName={props.patient?.firstName} 
    lastName={props.patient?.lastName} 
  />
);

export default PatientNameTemplate;
